import { useQuery } from '@tanstack/react-query';
import {
  DepartmentSectionCitiesParams,
  getDepartmentSectionCities,
} from '../apis/department';

export const useDepartmentSectionCitiesQuery = (
  params: DepartmentSectionCitiesParams
) => {
  return useQuery({
    queryKey: ['department-sections-cities', params.status],
    queryFn: () => getDepartmentSectionCities(params),
    retry: false,
    staleTime: 300000,
  });
};
